import { useEffect, useState } from 'react';
import {
  changeReportTrackingDisplay,
  changeReportTrackingPopupWindow,
  getAllReports,
  getReportsDueCurrentMonthAndYear,
  openNotificationDetailReport,
  selectTargetDayForReports,
} from '../../actions/reportTrackingAction';
import styles from '../../styles/calendar/Calendar.module.scss';
import {
  Calendar,
  CalendarCells,
  CalendarDays,
  CalendarHeader,
  CalendarProvider,
} from '../calendar';
import OperReqsFilters from './OpReqsFilters';

import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { ReportStatusCircle } from '../../services/SvgLibrary';
import { format } from 'date-fns';
const ReportTrackingCalendar = ({
  selectedDate,
  setSelectedDate,
  statuses,
  setStatuses,
  ...props
}) => {
  const [displayCommittee, setDisplayCommittee] = useState(false);
  const [displayMilestones, setDisplayMilestones] = useState(true);
  const [displayReports, setDisplayReports] = useState(true);
  const params = useParams();
  const [checkAllCommittees, setCheckAllCommittees] = useState(false);
  const [committees, setCommittees] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(format(new Date(), 'MMM yyyy'));
  const [preset, setPreset] = useState('');

  const toggleCommittee = title => {
    setCommittees(prevCommittees =>
      prevCommittees.map(com =>
        com.committee_name === title ? { ...com, show: !com.show } : com
      )
    );
  };
  const toggleStatus = statusKey => {
    setStatuses(prevStatuses => ({
      ...prevStatuses,
      [statusKey]: !prevStatuses[statusKey],
    }));
  };
  useEffect(() => {
    const currentDate = new Date();
    props.getReportsDueCurrentMonthAndYear(
      currentDate.getMonth() + 1,
      currentDate.getFullYear()
    );
    props.getAllReports();
    if (params.id) {
      props.openNotificationDetailReport(params.id);
      props.changeReportTrackingDisplay('detail');
    }
  }, []);

  useEffect(() => {
    if (committees.length === 0) {
      let filteredCommittees = props.allCommittees.filter(
        com => com.committee_name !== 'Unassigned'
      );

      setCommittees(
        filteredCommittees.map(com => {
          return { ...com, show: true };
        })
      );
      let lastPresetView = localStorage.getItem(
        'opReq-active-committee-selection'
      );
      let presetValues;
      if (lastPresetView && localStorage.getItem(lastPresetView)) {
        setPreset(lastPresetView);
        presetValues = localStorage.getItem(lastPresetView);
      } else {
        let newPreset = `opReq-committee-${props.userProfile.username}`;
        setPreset(newPreset);
        localStorage.setItem('opReq-active-committee-selection', newPreset);
        if (localStorage.getItem(newPreset)) {
          presetValues = localStorage.getItem(newPreset).split('|');
        } else {
          presetValues = props.allCommittees
            .map(com => com.committee_name)
            .join('|');
          localStorage.setItem(newPreset, presetValues);
        }
      }

      let savedCommittees = presetValues.split('|');
      setCommittees(
        props.allCommittees.map(com => {
          return { ...com, show: savedCommittees.includes(com.committee_name) };
        })
      );
    }
  }, [props.allCommittees, props.userProfile.username]);

  useEffect(() => {
    if (preset) {
      let committeeToSave = committees.reduce((acc, com) => {
        if (com.show) {
          acc.push(com.committee_name);
        }
        return acc;
      }, []);
      localStorage.setItem(preset, committeeToSave.join('|'));

      let checkAll = committees.every(com => com.show);
      if (checkAllCommittees !== checkAll) {
        setCheckAllCommittees(checkAll);
      }
    }
  }, [committees, preset, checkAllCommittees]);

  const allowedStatuses = [
    statuses.pastDue && 'past_due',
    statuses.completed && 'completed',
    statuses.received && 'received',
    statuses.upcoming && 'upcoming',
  ].filter(Boolean);
  const selectedCommittees = committees
    .filter(c => c.show)
    .map(c => c.committee_name);
  
  const filterTrackers = (all_trackers) => {
    let date_keys = Object.keys(all_trackers)
    let new_calendar_data = {}

    date_keys.forEach((day)=>{
      new_calendar_data[day] = all_trackers[day]
        .filter(opReq => {
          if (!displayReports && !displayMilestones) return false;
          if (displayReports && !displayMilestones)
            return opReq[1].tracker_type === 'report';
          if (!displayReports && displayMilestones)
            return opReq[1].tracker_type === 'milestone';
          return true;
        })
        .filter(opReq => allowedStatuses.includes(opReq[0]))
        .filter(opReq =>
          opReq[1].committees.some(({ committee_name }) =>
            selectedCommittees.includes(committee_name)
          )
        );
      })
    return new_calendar_data
  }
  const renderCellContent = (opReqsDueForTheDay, day) => {
    const currentDate = new Date(currentMonth);
    currentDate.setDate(day);

    // Chain filters for tracker type, status, and committee selection
    const filteredOpReqs = opReqsDueForTheDay
      .filter(opReq => {
        if (!displayReports && !displayMilestones) return false;
        if (displayReports && !displayMilestones)
          return opReq[1].tracker_type === 'report';
        if (!displayReports && displayMilestones)
          return opReq[1].tracker_type === 'milestone';
        return true;
      })
      .filter(opReq => allowedStatuses.includes(opReq[0]))
      .filter(opReq =>
        opReq[1].committees.some(({ committee_name }) =>
          selectedCommittees.includes(committee_name)
        )
      );

    const totalOpReqs = filteredOpReqs.length;
    const opTitles = filteredOpReqs.map((opReq, idx) => (
      <div
        key={`op-${opReq[1].title}-${idx}`}
        className={`${styles[opReq[0]]} ${styles['report-title-display']}`}>
        {opReq[1].title}
      </div>
    ));

    return (
      <div className={styles['report-calendar-day-container']}>
        {totalOpReqs > 3 &&
          statuses.pastDue &&
          filteredOpReqs.some(opReq => opReq[0] === 'past_due') && (
            <ReportStatusCircle
              classNameProp={styles['report-tracking-past-due']}
            />
          )}
        {totalOpReqs > 3 &&
          statuses.upcoming &&
          filteredOpReqs.some(opReq => opReq[0] === 'upcoming') && (
            <ReportStatusCircle
              classNameProp={styles['report-tracking-upcoming']}
            />
          )}
        {totalOpReqs > 3 &&
          statuses.received &&
          filteredOpReqs.some(opReq => opReq[0] === 'received') && (
            <ReportStatusCircle
              classNameProp={styles['report-tracking-received']}
            />
          )}
        {totalOpReqs > 3 &&
          statuses.completed &&
          filteredOpReqs.some(opReq => opReq[0] === 'completed') && (
            <ReportStatusCircle
              classNameProp={styles['report-tracking-completed']}
            />
          )}
        {totalOpReqs > 0 && (
          <>
            {totalOpReqs > 3 ? (
              <>
                <p className={styles['total-reports-num']}>{totalOpReqs}</p>
                <p>Trackers</p>
              </>
            ) : (
              opTitles
            )}
          </>
        )}
      </div>
    );
  };

  const handleOnDateClick = (day, filteredOpReqs) => {
    if (filteredOpReqs.length > 0) {
      setSelectedDate(day);
      filteredOpReqs = filteredOpReqs.map(opReq => {
        let newOp = opReq[1];
        newOp['op_status'] = opReq[0];
        return newOp;
      });
      props.selectTargetDayForReports(filteredOpReqs);
    }
  };
  const onCheckOrUncheckAllCheckbox = () => {
    setCheckAllCommittees(!checkAllCommittees);
    setCommittees(
      props.allCommittees.map(com => ({
        ...com,
        show: !checkAllCommittees,
      }))
    );
  };
  const togglePreset = presetOption => {
    localStorage.setItem('opReq-active-committee-selection', presetOption);
    if (localStorage.getItem(presetOption)) {
      let savedCommittees = localStorage.getItem(presetOption).split('|');
      setCommittees(prevCommittees =>
        prevCommittees.map(com => {
          return { ...com, show: savedCommittees.includes(com.committee_name) };
        })
      );
      setPreset(presetOption);
    } else {
      const defaultView = props.allCommittees.map(com => {
        return { ...com, show: true };
      });
      setCheckAllCommittees(false);
      setCommittees(defaultView);
      setPreset(presetOption);
      let comsToSave = defaultView.reduce((acc, com) => {
        if (com.show) {
          acc.push(com.committee_name);
        }
        return acc;
      }, []);
      localStorage.setItem(presetOption, comsToSave.join('|'));
    }
  };
  return (
    <CalendarProvider
      currentMonth={currentMonth}
      setCurrentMonth={setCurrentMonth}
      >
      <Calendar containerStyles={'reportsCalendar'}>
        <CalendarHeader
          isLoading={props.isLoading}
          getRequestCurrentMonthAndYear={
            props.getReportsDueCurrentMonthAndYear
          }>
          <OperReqsFilters
            addReportPermission={
              props.userProfile.permissions.reportTracking.add_report
            }
            changeReportTrackingDisplay={props.changeReportTrackingDisplay}
            changeReportTrackingPopupWindow={
              props.changeReportTrackingPopupWindow
            }
            checkAllCommittees={checkAllCommittees}
            committees={committees}
            displayCommittee={displayCommittee}
            displayMilestones={displayMilestones}
            displayReports={displayReports}
            onCheckOrUncheckAllCheckbox={onCheckOrUncheckAllCheckbox}
            preset={preset}
            statuses={statuses}
            setDisplayCommittee={setDisplayCommittee}
            setDisplayMilestones={setDisplayMilestones}
            setDisplayReports={setDisplayReports}
            toggleCommittee={toggleCommittee}
            togglePreset={togglePreset}
            toggleStatus={toggleStatus}
            userRole={props.userProfile.role}
          />
        </CalendarHeader>
        <CalendarDays />
        <CalendarCells
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
          onDateClick={handleOnDateClick}
          calendarData={props.isLoading ? [] : filterTrackers(props.dueReports) }
          renderCellContent={renderCellContent}
        />
      </Calendar>
    </CalendarProvider>
  );
};

const mapStateToProps = state => {
  return {
    allCommittees: state.userReducer.committees.filter(
      com => com.committee_name !== 'Unassigned'
    ),
    dueReports: state.reportTrackingReducer.dueReports,
    isLoading: state.reportTrackingReducer.isLoading,
    userProfile: state.userReducer.userProfile,
  };
};
const mapDispatchToProps = {
  changeReportTrackingPopupWindow,
  selectTargetDayForReports,
  getAllReports,
  getReportsDueCurrentMonthAndYear,
  changeReportTrackingDisplay,
  openNotificationDetailReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportTrackingCalendar);
